import {useNavigate, useParams} from "@tanstack/react-router"
import useChangelog from "@/components/changelog/context/_hook.changelog"
import {useEffect} from "react"
import ChangelogList from "@/components/changelog/changelog-list"

export default function ProgramChanges() {
    const {refKey} = useParams({strict: false})
    const navigate = useNavigate()
    const changelog = useChangelog()

    useEffect(() => {
        if (!changelog.currentProduct)
            return

        if (refKey != undefined)
            return

        navigate({
            to: `${location.pathname}/${changelog.currentProduct.refKey}`,
            replace: true
        }).then()
    }, [changelog.currentProduct])

    return <ChangelogList />
}
